import React from "react";
import { Col,Row } from "react-bootstrap";

import BannerForm from "./BannerForm";

const ManageBanners: React.FC = () => {
    return (
        <main className="container-fluid dashboard-bg">
            <div className="main main-app p-3 p-lg-4">
                <div className="min-vh-100 h-sm-auto d-flex">
                    <div className="p-4 w-100 bg-light">
                        <Row className="py-2">
                            <Col className="d-flex justify-content-between align-items-center">
                                <div className="fs-32">Manage Banner</div>
                            </Col>
                        </Row>
                        <BannerForm/>
                       {/* <BannerList /> */}
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ManageBanners;